import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`

let api = {
  // 季度数据上报——查询季度分页
  getQuarterlyDataByPage: `${baseUrl}/quarterlyData/getByPage`,

  // 季度数据上报——获取季度详情
  getQuarterlyDataByCode: `${baseUrl}/quarterlyData/getByCode`,

  // 季度数据上报——修改季度信息
  updateQuarterlyData: `${baseUrl}/quarterlyData/update`,

  // 季度数据上报——删除季度信息
  deleteQuarterlyData: `${baseUrl}/quarterlyData/del`,

  // 季度数据上报——快捷上报
  uploadQuarterlyDataByCode: `${baseUrl}/quarterlyData/uploadByCode`,

  // 季度数据上报——查询状态
  getQuarterlyDataStatus: `${baseUrl}/quarterlyData/getStatus`,

  // 年度数据上报——查询季度分页
  getAnnualDataByPage: `${baseUrl}/annualData/getPage`,

  // 年度数据上报——获取季度详情
  getAnnualDataByCode: `${baseUrl}/annualData/getByCode`,

  // 年度数据上报——修改季度信息
  updateAnnualData: `${baseUrl}/annualData/update`,

  // 年度数据上报——删除季度信息
  deleteAnnualData: `${baseUrl}/annualData/del`,

  // 年度数据上报——快捷上报
  uploadAnnualDataByCode: `${baseUrl}/annualData/uploadByCode`,

  // 年度数据上报——查询状态
  getAnnualDataStatus: `${baseUrl}/annualData/getStatus`,

  // 提交审批
  addApproveChain: `${baseUrl}/approveChain/add`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/PoliticalCommunication.js